import React from 'react';

export const ErrorComponent = ({ error }) => {
    return <p><center>An Error Occurred: {error.errorCode}. Please refresh to try again.</center></p>;
}